import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/LoginPage";

import MainLayout from "./layout/MainLayout";
import AuthGuard from "./components/AuthGuard";
import Location from "./pages/Location";

// Placeholder za Dashboard (dok ga ne izmjestis u poseban file)
const Dashboard = () => (
  <div style={{ padding: "20px" }}>
    <h2 style={{ color: "#284c7a", fontWeight: 700 }}>
      Dobrodošli na Dashboard
    </h2>
    <p>Ovdje će biti vaša statistika prodaje.</p>
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Javna ruta */}
        <Route path="/" element={<LoginPage />} />

        {/* Zaštićene rute */}
        <Route element={<AuthGuard />}>
          <Route element={<MainLayout />}>
            {/* Dashboard ruta */}
            <Route path="/dashboard" element={<Dashboard />} />

            {/* Dashboard ruta */}
            <Route path="/lokacija" element={<Location />} />
          </Route>
        </Route>

        {/* Redirect ako stranica ne postoji */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
